import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class GroupFreeAnswersApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;

        return {
            question: id,
            data: excludeHiddenAnswers(answersActors).map((answerActor) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { value } = response.getSnapshot().context;
                const data = value === CANTRATE_ID ? { cantRate: true } : { text: value as string };

                return { ...data, answer: id, bool: true };
            }),
            comment,
        };
    }

    public validate({ answersActors, params: { required } }: QuestionContext): boolean {
        if (required) {
            return excludeHiddenAnswers(answersActors).every(
                (answerActor) => !!answerActor.getSnapshot().context.response.getSnapshot().context.value,
            );
        }

        return true;
    }
}
